import LicenseBuilderSortable from "../licenseBuilderSortable";
import License from "../license";
import Guid from "~/helpers/guid";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import {LicenseStatusActionType} from "./licenseStatusActionType";
import {RelationType} from "../../../../common/models/relationType";
import RelativeTimePeriod from "../../../../common/models/relativeTimePeriod";
import Vue from "vue";
import StatusChangeInitiator from "./statusChangeInitiator";

export default class LicenseStatusAction extends LicenseBuilderSortable {
    name: string;
    button_class: string;
    action_type: LicenseStatusActionType;
    form_id: string;
    status_id: string;
    status_change_initiators: { [key: string]: StatusChangeInitiator } = {};
    status_change_available_status_client_ids: string[];
    status_change_period_start: RelativeTimePeriod;
    status_change_period_end: RelativeTimePeriod;
    available_on_listing_pages: boolean;
    update_license_dates: boolean;
    update_license_dates_type: number;
    action_client_id: string;
    except = ['license', 'status_change_period_start', 'status_change_period_end', 'status_change_initiators'];

    static repo: IRepo<LicenseStatusAction> = new Repo<LicenseStatusAction>('licenseStatusActions', LicenseStatusAction);

    constructor(license: License, json: any = {}) {
        super();
        this.defineProperty('client_id', json["client_id"] || Guid.create());
        this.defineProperty('name', '');
        this.defineProperty('button_class', 'blue');
        this.defineProperty('action_type', null);
        this.defineProperty('form_id', null);
        this.defineProperty('status_id', null);
        this.defineProperty('available_on_listing_pages', false);
        this.defineProperty('status_change_available_status_client_ids', []);
        this.defineProperty('update_license_dates', null);
        this.defineProperty('update_license_dates_type', null);
        this.defineProperty('sort_order', license.nextSortOrderFor(this.rootName));
        this.rootModel = license;
        this.parent = license;
        this.license = license;

        LicenseStatusAction.repo.add(this);
        Vue.set(license['status_actions'], this.client_id, this);

        this.loadFromJson(json, license.rootModel);
        if (!this.status_change_period_start) {
            const period = new RelativeTimePeriod(this, "status_change_period_start");
            this.trackCreationDeletion(period.client_id, null, period.asJson(), period);
        }
        if (!this.status_change_period_end) {
            const period = new RelativeTimePeriod(this, "status_change_period_end");
            this.trackCreationDeletion(period.client_id, null, period.asJson(), period);
        }
    }

    get statusChangeInitiatorsArray(): StatusChangeInitiator[] {
        return Object.keys(this.status_change_initiators).map(key => this.status_change_initiators[key]);
    }

    get rootName(): string {
        return 'status_actions';
    }

    get displayName(): string {
        return 'License Status Actions';
    }

    get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
        return {
            'status_change_initiators': { type: StatusChangeInitiator, relationType: RelationType.dictionary },
            'status_change_period_start': { type: RelativeTimePeriod, relationType: RelationType.singleObject },
            'status_change_period_end': { type: RelativeTimePeriod, relationType: RelationType.singleObject },
        };
    }

    createEmbeddedObject = {
        status_change_initiators: (parent, json): StatusChangeInitiator => { return new StatusChangeInitiator(parent);},
        status_change_period_start: (parent: LicenseStatusAction, json): RelativeTimePeriod => { return new RelativeTimePeriod(parent, 'status_change_period_start', json); },
        status_change_period_end: (parent: LicenseStatusAction, json): RelativeTimePeriod => { return new RelativeTimePeriod(parent, 'status_change_period_end', json); },
    };

    get isCollectionRoot(): boolean {
        return true;
    }
}